// AUTOGENERATED FILE
// see insights/generate_metric_types.py

export enum MetricTypes {
  PERCENT_OF_TOTAL_REVENUE = "% of Total Revenue",
  PERCENT_OF_TOTAL_SPEND = "% of Total Spend",
  AOV = "AOV",
  ACTIVE_CAMPAIGNS = "Active Campaigns",
  AD_PLATFORM_REPORTED_REVENUE = "Ad Platform Reported Revenue",
  ALL_TIME_REVENUE = "All Time Revenue",
  ALL_TIME_SPEND = "All Time Spend",
  CAC = "CAC",
  CUSTOMERS = "Customers",
  CUSTOMERS_EXISTING = "Customers - Existing",
  CUSTOMERS_NEW = "Customers - New",
  CUSTOMERS_NEW_PERCENTAGE = "Customers - New Percentage",
  CUSTOMERS_TOTAL = "Customers - Total",
  DISCOUNTS = "Discounts",
  AD_ADDED_TO_CART = "AD_ADDED_TO_CART",
  AD_CLICKS = "AD_CLICKS",
  AD_FREQUENCY = "AD_FREQUENCY",
  AD_IMPRESSIONS = "AD_IMPRESSIONS",
  AD_REACH = "AD_REACH",
  AD_SPEND = "AD_SPEND",
  AD_VIEWS = "AD_VIEWS",
  AD_CTR = "AD_CTR",
  AD_AOV = "AD_AOV",
  AD_CONVERSION_RATE = "AD_CONVERSION_RATE",
  AD_COST_PER_CONVERSION = "AD_COST_PER_CONVERSION",
  AD_COST_PER_IMPRESSION = "AD_COST_PER_IMPRESSION",
  AD_COST_PER_CLICK = "AD_COST_PER_CLICK",
  AD_ATTRIBUTED_CONVERSION_ROAS = "AD_ATTRIBUTED_CONVERSION_ROAS",
  AD_ATTRIBUTED_CONVERSION_VALUE = "AD_ATTRIBUTED_CONVERSION_VALUE",
  AD_ATTRIBUTED_CONVERSION_COUNT = "AD_ATTRIBUTED_CONVERSION_COUNT",
  MARKETING_EFFICIENCY_RATIO = "MARKETING_EFFICIENCY_RATIO",
  ACQUISITION_MARKETING_EFFICIENCY_RATIO = "ACQUISITION_MARKETING_EFFICIENCY_RATIO",
  BLENDED_AD_CLICKS = "BLENDED_AD_CLICKS",
  BLENDED_AD_FREQUENCY = "BLENDED_AD_FREQUENCY",
  BLENDED_AD_IMPRESSIONS = "BLENDED_AD_IMPRESSIONS",
  BLENDED_AD_REACH = "BLENDED_AD_REACH",
  BLENDED_AD_SPEND = "BLENDED_AD_SPEND",
  BLENDED_AD_VIEWS = "BLENDED_AD_VIEWS",
  BLENDED_AD_CTR = "BLENDED_AD_CTR",
  BLENDED_AD_AOV = "BLENDED_AD_AOV",
  BLENDED_AD_CONVERSION_RATE = "BLENDED_AD_CONVERSION_RATE",
  BLENDED_AD_COST_PER_CONVERSION = "BLENDED_AD_COST_PER_CONVERSION",
  BLENDED_AD_COST_PER_IMPRESSION = "BLENDED_AD_COST_PER_IMPRESSION",
  BLENDED_AD_COST_PER_CLICK = "BLENDED_AD_COST_PER_CLICK",
  BLENDED_AD_ATTRIBUTED_CONVERSION_COUNT = "BLENDED_AD_ATTRIBUTED_CONVERSION_COUNT",
  BLENDED_AD_ATTRIBUTED_CONVERSION_VALUE = "BLENDED_AD_ATTRIBUTED_CONVERSION_VALUE",
  BLENDED_AD_ATTRIBUTED_CONVERSION_ROAS = "BLENDED_AD_ATTRIBUTED_CONVERSION_ROAS",
  BLENDED_AD_RELATIVE_PERCENTAGE_SPEND = "BLENDED_AD_RELATIVE_PERCENTAGE_SPEND",
  META_AD_ADDED_TO_CART = "META_AD_ADDED_TO_CART",
  META_AD_CLICKS = "META_AD_CLICKS",
  META_AD_FREQUENCY = "META_AD_FREQUENCY",
  META_AD_IMPRESSIONS = "META_AD_IMPRESSIONS",
  META_AD_REACH = "META_AD_REACH",
  META_AD_SPEND = "META_AD_SPEND",
  META_AD_VIEWS = "META_AD_VIEWS",
  META_AD_CTR = "META_AD_CTR",
  META_AD_AOV = "META_AD_AOV",
  META_AD_CONVERSION_RATE = "META_AD_CONVERSION_RATE",
  META_AD_COST_PER_CONVERSION = "META_AD_COST_PER_CONVERSION",
  META_AD_COST_PER_IMPRESSION = "META_AD_COST_PER_IMPRESSION",
  META_AD_COST_PER_MILLE = "META_AD_COST_PER_MILLE",
  META_AD_COST_PER_CLICK = "META_AD_COST_PER_CLICK",
  META_AD_ATTRIBUTED_CONVERSION_COUNT = "META_AD_ATTRIBUTED_CONVERSION_COUNT",
  META_AD_ATTRIBUTED_CONVERSION_VALUE = "META_AD_ATTRIBUTED_CONVERSION_VALUE",
  META_AD_ATTRIBUTED_CONVERSION_ROAS = "META_AD_ATTRIBUTED_CONVERSION_ROAS",
  META_AD_RELATIVE_PERCENTAGE_SPEND = "META_AD_RELATIVE_PERCENTAGE_SPEND",
  GOOGLE_AD_CLICKS = "GOOGLE_AD_CLICKS",
  GOOGLE_AD_FREQUENCY = "GOOGLE_AD_FREQUENCY",
  GOOGLE_AD_IMPRESSIONS = "GOOGLE_AD_IMPRESSIONS",
  GOOGLE_AD_REACH = "GOOGLE_AD_REACH",
  GOOGLE_AD_SPEND = "GOOGLE_AD_SPEND",
  GOOGLE_AD_VIEWS = "GOOGLE_AD_VIEWS",
  GOOGLE_AD_CTR = "GOOGLE_AD_CTR",
  GOOGLE_AD_AOV = "GOOGLE_AD_AOV",
  GOOGLE_AD_CONVERSION_RATE = "GOOGLE_AD_CONVERSION_RATE",
  GOOGLE_AD_COST_PER_CONVERSION = "GOOGLE_AD_COST_PER_CONVERSION",
  GOOGLE_AD_COST_PER_IMPRESSION = "GOOGLE_AD_COST_PER_IMPRESSION",
  GOOGLE_AD_COST_PER_CLICK = "GOOGLE_AD_COST_PER_CLICK",
  GOOGLE_AD_ATTRIBUTED_CONVERSION_COUNT = "GOOGLE_AD_ATTRIBUTED_CONVERSION_COUNT",
  GOOGLE_AD_ATTRIBUTED_CONVERSION_VALUE = "GOOGLE_AD_ATTRIBUTED_CONVERSION_VALUE",
  GOOGLE_AD_ATTRIBUTED_CONVERSION_ROAS = "GOOGLE_AD_ATTRIBUTED_CONVERSION_ROAS",
  GOOGLE_AD_RELATIVE_PERCENTAGE_SPEND = "GOOGLE_AD_RELATIVE_PERCENTAGE_SPEND",
  TIKTOK_AD_SPEND = "TIKTOK_AD_SPEND",
  TIKTOK_ACCOUNT_ID = "TIKTOK_ACCOUNT_ID",
  TIKTOK_ACCOUNT_NAME = "TIKTOK_ACCOUNT_NAME",
  TIKTOK_WAYFLYER_BC_ID = "TIKTOK_WAYFLYER_BC_ID",
  GROSS_ITEM_QUANTITY = "GROSS_ITEM_QUANTITY",
  GROSS_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_PRODUCTS = "GROSS_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_PRODUCTS",
  GROSS_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_REFUNDS = "GROSS_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_REFUNDS",
  GROSS_PRODUCT_REVENUE_FROM_ORDER_PROPORTION_LESS_DISCOUNTS = "GROSS_PRODUCT_REVENUE_FROM_ORDER_PROPORTION_LESS_DISCOUNTS",
  GROSS_PRODUCT_REVENUE_FROM_ORDER_PROPORTION_LESS_DISCOUNTS_LESS_REFUNDED_AMOUNT_FROM_ORDERS = "GROSS_PRODUCT_REVENUE_FROM_ORDER_PROPORTION_LESS_DISCOUNTS_LESS_REFUNDED_AMOUNT_FROM_ORDERS",
  GROSS_PRODUCT_REVENUE_FROM_ORDER_PROPORTION_LESS_DISCOUNTS_LESS_REFUNDED_AMOUNT_FROM_REFUNDS = "GROSS_PRODUCT_REVENUE_FROM_ORDER_PROPORTION_LESS_DISCOUNTS_LESS_REFUNDED_AMOUNT_FROM_REFUNDS",
  GROSS_REVENUE_LESS_DISCOUNTS_LESS_REFUNDS_BY_REFUNDED_DATE_PLUS_SHIPPING_PLUS_TAX = "GROSS_REVENUE_LESS_DISCOUNTS_LESS_REFUNDS_BY_REFUNDED_DATE_PLUS_SHIPPING_PLUS_TAX",
  GROSS_REVENUE_LESS_DISCOUNTS_LESS_REFUNDS_FROM_ORDERS_PLUS_SHIPPING_PLUS_TAX = "GROSS_REVENUE_LESS_DISCOUNTS_LESS_REFUNDS_FROM_ORDERS_PLUS_SHIPPING_PLUS_TAX",
  GROSS_REVENUE_LESS_DISCOUNTS_LESS_REFUNDS_PLUS_SHIPPING_PLUS_TAX = "GROSS_REVENUE_LESS_DISCOUNTS_LESS_REFUNDS_PLUS_SHIPPING_PLUS_TAX",
  GROSS_REVENUE_LESS_DISCOUNTS_PLUS_SHIPPING_PLUS_TAX = "GROSS_REVENUE_LESS_DISCOUNTS_PLUS_SHIPPING_PLUS_TAX",
  ACQUISITION_GROSS_REVENUE_LESS_DISCOUNTS_PLUS_SHIPPING_PLUS_TAX = "ACQUISITION_GROSS_REVENUE_LESS_DISCOUNTS_PLUS_SHIPPING_PLUS_TAX",
  GROSS_REVENUE = "Gross Revenue",
  NEW_CUSTOMER_ITEM_QUANTITY = "NEW_CUSTOMER_ITEM_QUANTITY",
  NEW_CUSTOMER_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_PRODUCTS = "NEW_CUSTOMER_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_PRODUCTS",
  ITEM_LEVEL_NEW_CUSTOMER_PERCENT = "ITEM_LEVEL_NEW_CUSTOMER_PERCENT",
  ITEM_LEVEL_NEW_CUSTOMER_PERCENT_FROM_PRODUCTS = "ITEM_LEVEL_NEW_CUSTOMER_PERCENT_FROM_PRODUCTS",
  ITEM_LEVEL_RETURN_RATE_FROM_PRODUCTS = "ITEM_LEVEL_RETURN_RATE_FROM_PRODUCTS",
  ITEM_LEVEL_RETURN_RATE_FROM_REFUNDS = "ITEM_LEVEL_RETURN_RATE_FROM_REFUNDS",
  RETURNING_CUSTOMER_PERCENTAGE = "RETURNING_CUSTOMER_PERCENTAGE",
  LTV = "LTV",
  LINK_CLICKS = "Link Clicks",
  MARKETING_SPEND = "Marketing Spend",
  LTV_CAC_MONTH = "Month",
  MONTH_FIRST_ORDER = "Month First Order",
  NET_QUANTITY = "Net Quantity",
  NET_REVENUE = "Net Revenue",
  NET_SALES_EXISTING = "Net Sales - Existing",
  NET_SALES_NEW = "Net Sales - New",
  NET_SALES_NEW_PERCENTAGE = "Net Sales - New Percentage",
  NET_SALES_TOTAL = "Net Sales - Total",
  NEW_CUSTOMERS = "New Customers",
  ORDERS = "Orders",
  ORDERS_EXISTING = "Orders - Existing",
  ORDERS_NEW = "Orders - New",
  ORDERS_NEW_PERCENTAGE = "Orders - New Percentage",
  ORDERS_TOTAL = "Orders - Total",
  PRODUCT_QUANTITY = "PRODUCT_QUANTITY",
  PRODUCT_REFUNDS_FROM_PRODUCTS = "PRODUCT_REFUNDS_FROM_PRODUCTS",
  PRODUCT_REFUNDS_FROM_REFUNDS = "PRODUCT_REFUNDS_FROM_REFUNDS",
  QUANTITY = "Quantity",
  LTV_CAC_QUARTER = "Quarter",
  QUARTER_FIRST_ORDER = "Quarter First Order",
  ROAS = "ROAS",
  REFUNDS_PERCENT = "Refunds %",
  RETURN_RATE = "Return Rate",
  RETURNS = "Returns",
  REVENUE = "Revenue",
  SALES = "Sales",
  SALES_EXISTING = "Sales - Existing",
  SALES_NEW = "Sales - New",
  SALES_NEW_PERCENTAGE = "Sales - New Percentage",
  SALES_TOTAL = "Sales - Total",
  SALES_EXCLUDING_REFUNDS = "Sales excluding Refunds",
  TOTAL_ORDERED_ITEM_QUANTITY = "TOTAL_ORDERED_ITEM_QUANTITY",
  TOTAL_ORDERED_ITEM_QUANTITY_LESS_REFUNDED_ITEM_QUANTITY = "TOTAL_ORDERED_ITEM_QUANTITY_LESS_REFUNDED_ITEM_QUANTITY",
  TOTAL_ORDERED_ITEM_QUANTITY_LESS_REFUNDED_ITEM_QUANTITY_BY_REFUNDED_DATE = "TOTAL_ORDERED_ITEM_QUANTITY_LESS_REFUNDED_ITEM_QUANTITY_BY_REFUNDED_DATE",
  TOTAL_ORDER_QUANTITY = "TOTAL_ORDER_QUANTITY",
  TOTAL_REFUNDED_ITEM_QUANTITY = "TOTAL_REFUNDED_ITEM_QUANTITY",
  TOTAL_REFUNDED_ITEM_QUANTITY_BY_REFUNDED_DATE = "TOTAL_REFUNDED_ITEM_QUANTITY_BY_REFUNDED_DATE",
  TOTAL_UNIQUE_CUSTOMER_COUNT = "TOTAL_UNIQUE_CUSTOMER_COUNT",
  TOTAL_UNIQUE_NEW_CUSTOMER_COUNT = "TOTAL_UNIQUE_NEW_CUSTOMER_COUNT",
  TOTAL_SALES = "Total Sales",
  TRANSACTIONS = "Transactions",
  LTV_CAC_YEAR = "Year",
  YEAR_FIRST_ORDER = "Year First Order",
  ADDITIONAL_COGS_AND_SHIPPING = "CoGS and Shipping",
  ADDITIONAL_OPEX = "OpEx",
  COGS = "Cost of Goods Sold",
  GROSS_PROFIT = "Gross Profit",
  GROSS_MARGIN_PERCENTAGE = "Gross Margin %",
  FCP = "fcp",
  TEST_METRIC = "TEST_METRIC",
  PROFIT = "Profit",
  PERCENTAGE_OF_SPEND = "% of Spend",
  PERCENTAGE_OF_TOTAL_AD_SPEND = "PERCENTAGE_OF_TOTAL_AD_SPEND",
  AVERAGE_UNITS_PER_ORDER = "AVERAGE_UNITS_PER_ORDER",
  REFUNDED_ITEM_PERCENTAGE = "REFUNDED_ITEM_PERCENTAGE",
  REFUNDED_ITEM_PERCENTAGE_BY_REFUNDED_DATE = "REFUNDED_ITEM_PERCENTAGE_BY_REFUNDED_DATE",
  AVERAGE_DAILY_UNITS = "AVERAGE_DAILY_UNITS",
  SALES_VELOCITY_THIRTY_DAYS = "SALES_VELOCITY_THIRTY_DAYS",
  GROSS_PRODUCT_REVENUE = "GROSS_PRODUCT_REVENUE",
  PRODUCT_LEVEL_DISCOUNT_PCT = "PRODUCT_LEVEL_DISCOUNT_PCT",
  PRODUCT_LEVEL_DISCOUNT_VALUE = "PRODUCT_LEVEL_DISCOUNT_VALUE",
  SESSION_COUNT = "SESSION_COUNT",
  CONVERSION_RATE = "CONVERSION_RATE",
  STORE_NAME = "STORE_NAME",
  ALLTIME_AOV = "Alltime AOV",
  ALLTIME_FREQUENCY = "Alltime Frequency",
  ALLTIME_LTV = "Alltime LTV",
  ALLTIME_NET_REVENUE = "Alltime Net Revenue",
  ALLTIME_UNIQUE_CUSTOMER_COUNT = "Alltime Unique Customer Count",
  ALLTIME_ORDERS = "Alltime Orders",
  ALLTIME_CUSTOMER_CURRENCY_CPC_SPEND = "Alltime CPC Spend",
  ALLTIME_CAC = "Alltime CAC",
  SAME_MONTH_AOV = "Same Month AOV",
  SAME_MONTH_FREQUENCY = "Same Month Frequency",
  SAME_MONTH_LTV = "Same Month LTV",
  SAME_MONTH_NET_REVENUE = "Same Month Net Revenue",
  SAME_MONTH_UNIQUE_CUSTOMER_COUNT = "Same Month Unique Customer Count",
  SAME_MONTH_ORDERS = "Same Month Orders",
  SAME_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Same Month CPC Spend",
  SAME_MONTH_CAC = "Same Month CAC",
  ONE_MONTH_AOV = "One Month AOV",
  ONE_MONTH_FREQUENCY = "One Month Frequency",
  ONE_MONTH_LTV = "One Month LTV",
  ONE_MONTH_NET_REVENUE = "One Month Net Revenue",
  ONE_MONTH_UNIQUE_CUSTOMER_COUNT = "One Month Unique Customer Count",
  ONE_MONTH_ORDERS = "One Month Orders",
  ONE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "One Month CPC Spend",
  ONE_MONTH_CAC = "One Month CAC",
  TWO_MONTH_AOV = "Two Month AOV",
  TWO_MONTH_FREQUENCY = "Two Month Frequency",
  TWO_MONTH_LTV = "Two Month LTV",
  TWO_MONTH_NET_REVENUE = "Two Month Net Revenue",
  TWO_MONTH_UNIQUE_CUSTOMER_COUNT = "Two Month Unique Customer Count",
  TWO_MONTH_ORDERS = "Two Month Orders",
  TWO_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Two Month CPC Spend",
  TWO_MONTH_CAC = "Two Month CAC",
  THREE_MONTH_AOV = "Three Month AOV",
  THREE_MONTH_FREQUENCY = "Three Month Frequency",
  THREE_MONTH_LTV = "Three Month LTV",
  THREE_MONTH_NET_REVENUE = "Three Month Net Revenue",
  THREE_MONTH_UNIQUE_CUSTOMER_COUNT = "Three Month Unique Customer Count",
  THREE_MONTH_ORDERS = "Three Month Orders",
  THREE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Three Month CPC Spend",
  THREE_MONTH_CAC = "Three Month CAC",
  FOUR_MONTH_AOV = "Four Month AOV",
  FOUR_MONTH_FREQUENCY = "Four Month Frequency",
  FOUR_MONTH_LTV = "Four Month LTV",
  FOUR_MONTH_NET_REVENUE = "Four Month Net Revenue",
  FOUR_MONTH_UNIQUE_CUSTOMER_COUNT = "Four Month Unique Customer Count",
  FOUR_MONTH_ORDERS = "Four Month Orders",
  FOUR_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Four Month CPC Spend",
  FOUR_MONTH_CAC = "Four Month CAC",
  FIVE_MONTH_AOV = "Five Month AOV",
  FIVE_MONTH_FREQUENCY = "Five Month Frequency",
  FIVE_MONTH_LTV = "Five Month LTV",
  FIVE_MONTH_NET_REVENUE = "Five Month Net Revenue",
  FIVE_MONTH_UNIQUE_CUSTOMER_COUNT = "Five Month Unique Customer Count",
  FIVE_MONTH_ORDERS = "Five Month Orders",
  FIVE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Five Month CPC Spend",
  FIVE_MONTH_CAC = "Five Month CAC",
  SIX_MONTH_AOV = "Six Month AOV",
  SIX_MONTH_FREQUENCY = "Six Month Frequency",
  SIX_MONTH_LTV = "Six Month LTV",
  SIX_MONTH_NET_REVENUE = "Six Month Net Revenue",
  SIX_MONTH_UNIQUE_CUSTOMER_COUNT = "Six Month Unique Customer Count",
  SIX_MONTH_ORDERS = "Six Month Orders",
  SIX_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Six Month CPC Spend",
  SIX_MONTH_CAC = "Six Month CAC",
  SEVEN_MONTH_AOV = "Seven Month AOV",
  SEVEN_MONTH_FREQUENCY = "Seven Month Frequency",
  SEVEN_MONTH_LTV = "Seven Month LTV",
  SEVEN_MONTH_NET_REVENUE = "Seven Month Net Revenue",
  SEVEN_MONTH_UNIQUE_CUSTOMER_COUNT = "Seven Month Unique Customer Count",
  SEVEN_MONTH_ORDERS = "Seven Month Orders",
  SEVEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Seven Month CPC Spend",
  SEVEN_MONTH_CAC = "Seven Month CAC",
  EIGHT_MONTH_AOV = "Eight Month AOV",
  EIGHT_MONTH_FREQUENCY = "Eight Month Frequency",
  EIGHT_MONTH_LTV = "Eight Month LTV",
  EIGHT_MONTH_NET_REVENUE = "Eight Month Net Revenue",
  EIGHT_MONTH_UNIQUE_CUSTOMER_COUNT = "Eight Month Unique Customer Count",
  EIGHT_MONTH_ORDERS = "Eight Month Orders",
  EIGHT_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Eight Month CPC Spend",
  EIGHT_MONTH_CAC = "Eight Month CAC",
  NINE_MONTH_AOV = "Nine Month AOV",
  NINE_MONTH_FREQUENCY = "Nine Month Frequency",
  NINE_MONTH_LTV = "Nine Month LTV",
  NINE_MONTH_NET_REVENUE = "Nine Month Net Revenue",
  NINE_MONTH_UNIQUE_CUSTOMER_COUNT = "Nine Month Unique Customer Count",
  NINE_MONTH_ORDERS = "Nine Month Orders",
  NINE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Nine Month CPC Spend",
  NINE_MONTH_CAC = "Nine Month CAC",
  TEN_MONTH_AOV = "Ten Month AOV",
  TEN_MONTH_FREQUENCY = "Ten Month Frequency",
  TEN_MONTH_LTV = "Ten Month LTV",
  TEN_MONTH_NET_REVENUE = "Ten Month Net Revenue",
  TEN_MONTH_UNIQUE_CUSTOMER_COUNT = "Ten Month Unique Customer Count",
  TEN_MONTH_ORDERS = "Ten Month Orders",
  TEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Ten Month CPC Spend",
  TEN_MONTH_CAC = "Ten Month CAC",
  ELEVEN_MONTH_AOV = "Eleven Month AOV",
  ELEVEN_MONTH_FREQUENCY = "Eleven Month Frequency",
  ELEVEN_MONTH_LTV = "Eleven Month LTV",
  ELEVEN_MONTH_NET_REVENUE = "Eleven Month Net Revenue",
  ELEVEN_MONTH_UNIQUE_CUSTOMER_COUNT = "Eleven Month Unique Customer Count",
  ELEVEN_MONTH_ORDERS = "Eleven Month Orders",
  ELEVEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Eleven Month CPC Spend",
  ELEVEN_MONTH_CAC = "Eleven Month CAC",
  TWELVE_MONTH_AOV = "Twelve Month AOV",
  TWELVE_MONTH_FREQUENCY = "Twelve Month Frequency",
  TWELVE_MONTH_LTV = "Twelve Month LTV",
  TWELVE_MONTH_NET_REVENUE = "Twelve Month Net Revenue",
  TWELVE_MONTH_UNIQUE_CUSTOMER_COUNT = "Twelve Month Unique Customer Count",
  TWELVE_MONTH_ORDERS = "Twelve Month Orders",
  TWELVE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Twelve Month CPC Spend",
  TWELVE_MONTH_CAC = "Twelve Month CAC",
  THIRTEEN_MONTH_AOV = "Thirteen Month AOV",
  THIRTEEN_MONTH_FREQUENCY = "Thirteen Month Frequency",
  THIRTEEN_MONTH_LTV = "Thirteen Month LTV",
  THIRTEEN_MONTH_NET_REVENUE = "Thirteen Month Net Revenue",
  THIRTEEN_MONTH_UNIQUE_CUSTOMER_COUNT = "Thirteen Month Unique Customer Count",
  THIRTEEN_MONTH_ORDERS = "Thirteen Month Orders",
  THIRTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Thirteen Month CPC Spend",
  THIRTEEN_MONTH_CAC = "Thirteen Month CAC",
  FOURTEEN_MONTH_AOV = "Fourteen Month AOV",
  FOURTEEN_MONTH_FREQUENCY = "Fourteen Month Frequency",
  FOURTEEN_MONTH_LTV = "Fourteen Month LTV",
  FOURTEEN_MONTH_NET_REVENUE = "Fourteen Month Net Revenue",
  FOURTEEN_MONTH_UNIQUE_CUSTOMER_COUNT = "Fourteen Month Unique Customer Count",
  FOURTEEN_MONTH_ORDERS = "Fourteen Month Orders",
  FOURTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Fourteen Month CPC Spend",
  FOURTEEN_MONTH_CAC = "Fourteen Month CAC",
  FIFTEEN_MONTH_AOV = "Fifteen Month AOV",
  FIFTEEN_MONTH_FREQUENCY = "Fifteen Month Frequency",
  FIFTEEN_MONTH_LTV = "Fifteen Month LTV",
  FIFTEEN_MONTH_NET_REVENUE = "Fifteen Month Net Revenue",
  FIFTEEN_MONTH_UNIQUE_CUSTOMER_COUNT = "Fifteen Month Unique Customer Count",
  FIFTEEN_MONTH_ORDERS = "Fifteen Month Orders",
  FIFTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Fifteen Month CPC Spend",
  FIFTEEN_MONTH_CAC = "Fifteen Month CAC",
  SIXTEEN_MONTH_AOV = "Sixteen Month AOV",
  SIXTEEN_MONTH_FREQUENCY = "Sixteen Month Frequency",
  SIXTEEN_MONTH_LTV = "Sixteen Month LTV",
  SIXTEEN_MONTH_NET_REVENUE = "Sixteen Month Net Revenue",
  SIXTEEN_MONTH_UNIQUE_CUSTOMER_COUNT = "Sixteen Month Unique Customer Count",
  SIXTEEN_MONTH_ORDERS = "Sixteen Month Orders",
  SIXTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Sixteen Month CPC Spend",
  SIXTEEN_MONTH_CAC = "Sixteen Month CAC",
  SEVENTEEN_MONTH_AOV = "Seventeen Month AOV",
  SEVENTEEN_MONTH_FREQUENCY = "Seventeen Month Frequency",
  SEVENTEEN_MONTH_LTV = "Seventeen Month LTV",
  SEVENTEEN_MONTH_NET_REVENUE = "Seventeen Month Net Revenue",
  SEVENTEEN_MONTH_UNIQUE_CUSTOMER_COUNT = "Seventeen Month Unique Customer Count",
  SEVENTEEN_MONTH_ORDERS = "Seventeen Month Orders",
  SEVENTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Seventeen Month CPC Spend",
  SEVENTEEN_MONTH_CAC = "Seventeen Month CAC",
  EIGHTEEN_MONTH_AOV = "Eighteen Month AOV",
  EIGHTEEN_MONTH_FREQUENCY = "Eighteen Month Frequency",
  EIGHTEEN_MONTH_LTV = "Eighteen Month LTV",
  EIGHTEEN_MONTH_NET_REVENUE = "Eighteen Month Net Revenue",
  EIGHTEEN_MONTH_UNIQUE_CUSTOMER_COUNT = "Eighteen Month Unique Customer Count",
  EIGHTEEN_MONTH_ORDERS = "Eighteen Month Orders",
  EIGHTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Eighteen Month CPC Spend",
  EIGHTEEN_MONTH_CAC = "Eighteen Month CAC",
  NINETEEN_MONTH_AOV = "Nineteen Month AOV",
  NINETEEN_MONTH_FREQUENCY = "Nineteen Month Frequency",
  NINETEEN_MONTH_LTV = "Nineteen Month LTV",
  NINETEEN_MONTH_NET_REVENUE = "Nineteen Month Net Revenue",
  NINETEEN_MONTH_UNIQUE_CUSTOMER_COUNT = "Nineteen Month Unique Customer Count",
  NINETEEN_MONTH_ORDERS = "Nineteen Month Orders",
  NINETEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Nineteen Month CPC Spend",
  NINETEEN_MONTH_CAC = "Nineteen Month CAC",
  TWENTY_MONTH_AOV = "Twenty Month AOV",
  TWENTY_MONTH_FREQUENCY = "Twenty Month Frequency",
  TWENTY_MONTH_LTV = "Twenty Month LTV",
  TWENTY_MONTH_NET_REVENUE = "Twenty Month Net Revenue",
  TWENTY_MONTH_UNIQUE_CUSTOMER_COUNT = "Twenty Month Unique Customer Count",
  TWENTY_MONTH_ORDERS = "Twenty Month Orders",
  TWENTY_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Twenty Month CPC Spend",
  TWENTY_MONTH_CAC = "Twenty Month CAC",
  TWENTY_ONE_MONTH_AOV = "Twenty-One Month AOV",
  TWENTY_ONE_MONTH_FREQUENCY = "Twenty-One Month Frequency",
  TWENTY_ONE_MONTH_LTV = "Twenty-One Month LTV",
  TWENTY_ONE_MONTH_NET_REVENUE = "Twenty-One Month Net Revenue",
  TWENTY_ONE_MONTH_UNIQUE_CUSTOMER_COUNT = "Twenty-One Month Unique Customer Count",
  TWENTY_ONE_MONTH_ORDERS = "Twenty-One Month Orders",
  TWENTY_ONE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Twenty-One Month CPC Spend",
  TWENTY_ONE_MONTH_CAC = "Twenty-One Month CAC",
  TWENTY_TWO_MONTH_AOV = "Twenty-Two Month AOV",
  TWENTY_TWO_MONTH_FREQUENCY = "Twenty-Two Month Frequency",
  TWENTY_TWO_MONTH_LTV = "Twenty-Two Month LTV",
  TWENTY_TWO_MONTH_NET_REVENUE = "Twenty-Two Month Net Revenue",
  TWENTY_TWO_MONTH_UNIQUE_CUSTOMER_COUNT = "Twenty-Two Month Unique Customer Count",
  TWENTY_TWO_MONTH_ORDERS = "Twenty-Two Month Orders",
  TWENTY_TWO_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Twenty-Two Month CPC Spend",
  TWENTY_TWO_MONTH_CAC = "Twenty-Two Month CAC",
  TWENTY_THREE_MONTH_AOV = "Twenty-Three Month AOV",
  TWENTY_THREE_MONTH_FREQUENCY = "Twenty-Three Month Frequency",
  TWENTY_THREE_MONTH_LTV = "Twenty-Three Month LTV",
  TWENTY_THREE_MONTH_NET_REVENUE = "Twenty-Three Month Net Revenue",
  TWENTY_THREE_MONTH_UNIQUE_CUSTOMER_COUNT = "Twenty-Three Month Unique Customer Count",
  TWENTY_THREE_MONTH_ORDERS = "Twenty-Three Month Orders",
  TWENTY_THREE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Twenty-Three Month CPC Spend",
  TWENTY_THREE_MONTH_CAC = "Twenty-Three Month CAC",
  TWENTY_FOUR_MONTH_AOV = "Twenty-Four Month AOV",
  TWENTY_FOUR_MONTH_FREQUENCY = "Twenty-Four Month Frequency",
  TWENTY_FOUR_MONTH_LTV = "Twenty-Four Month LTV",
  TWENTY_FOUR_MONTH_NET_REVENUE = "Twenty-Four Month Net Revenue",
  TWENTY_FOUR_MONTH_UNIQUE_CUSTOMER_COUNT = "Twenty-Four Month Unique Customer Count",
  TWENTY_FOUR_MONTH_ORDERS = "Twenty-Four Month Orders",
  TWENTY_FOUR_MONTH_CUSTOMER_CURRENCY_CPC_SPEND = "Twenty-Four Month CPC Spend",
  TWENTY_FOUR_MONTH_CAC = "Twenty-Four Month CAC",
  META_AD_ACCOUNT_ID = "META_AD_ACCOUNT_ID",
  META_AD_ACCOUNT_NAME = "META_AD_ACCOUNT_NAME",
  ADSET_FIRST_USED = "ADSET_FIRST_USED",
  ADSET_LAST_USED = "ADSET_LAST_USED",
  ADSET_REGION = "ADSET_REGION",
  ADSET_NAME = "ADSET_NAME",
  ADSET_AUDIENCE = "ADSET_AUDIENCE",
  ADSET_IS_CATALOG = "ADSET_IS_CATALOG",
  CAMPAIGN_OBJECTIVE = "CAMPAIGN_OBJECTIVE",
  AUDIENCE_ENRICHMENT_ADSET_TARGETING = "AUDIENCE_ENRICHMENT_ADSET_TARGETING",
  ADSET_TARGETING = "ADSET_TARGETING",
  BENCHMARK_SAMPLE_SIZE = "BENCHMARK_SAMPLE_SIZE",
  BENCHMARKED_MER = "BENCHMARKED_MER",
  BENCHMARKED_AMER = "BENCHMARKED_AMER",
  BENCHMARKED_BLENDED_AD_ATTRIBUTED_CONVERSION_ROAS = "BENCHMARKED_BLENDED_AD_ATTRIBUTED_CONVERSION_ROAS",
  BENCHMARKED_BLENDED_AD_COST_PER_IMPRESSION = "BENCHMARKED_BLENDED_AD_COST_PER_IMPRESSION",
  BENCHMARKED_BLENDED_AD_CLICK_THROUGH_RATE = "BENCHMARKED_BLENDED_AD_CLICK_THROUGH_RATE",
  BENCHMARKED_BLENDED_AD_COST_PER_CLICK = "BENCHMARKED_BLENDED_AD_COST_PER_CLICK",
  BENCHMARKED_GOOGLE_AD_ATTRIBUTED_CONVERSION_ROAS = "BENCHMARKED_GOOGLE_AD_ATTRIBUTED_CONVERSION_ROAS",
  BENCHMARKED_GOOGLE_AD_COST_PER_IMPRESSION = "BENCHMARKED_GOOGLE_AD_COST_PER_IMPRESSION",
  BENCHMARKED_GOOGLE_AD_CLICK_THROUGH_RATE = "BENCHMARKED_GOOGLE_AD_CLICK_THROUGH_RATE",
  BENCHMARKED_GOOGLE_AD_COST_PER_CLICK = "BENCHMARKED_GOOGLE_AD_COST_PER_CLICK",
  BENCHMARKED_GOOGLE_AD_RELATIVE_PERCENTAGE_SPEND = "BENCHMARKED_GOOGLE_AD_RELATIVE_PERCENTAGE_SPEND",
  BENCHMARKED_META_AD_ATTRIBUTED_CONVERSION_ROAS = "BENCHMARKED_META_AD_ATTRIBUTED_CONVERSION_ROAS",
  BENCHMARKED_META_AD_COST_PER_IMPRESSION = "BENCHMARKED_META_AD_COST_PER_IMPRESSION",
  BENCHMARKED_META_AD_CLICK_THROUGH_RATE = "BENCHMARKED_META_AD_CLICK_THROUGH_RATE",
  BENCHMARKED_META_AD_COST_PER_CLICK = "BENCHMARKED_META_AD_COST_PER_CLICK",
  BENCHMARKED_META_AD_RELATIVE_PERCENTAGE_SPEND = "BENCHMARKED_META_AD_RELATIVE_PERCENTAGE_SPEND",
}

export enum Dimensions {
  ADGROUP_ID = "Adgroup ID",
  ADGROUP_NAME = "Adgroup Name",
  ADSET = "Adset",
  ADSET_ID = "Adset ID",
  AUDIENCE = "Audience",
  AUDIENCE_TYPE = "Audience Type",
  CAMPAIGN = "Campaign",
  CAMPAIGN_ID = "Campaign ID",
  CAMPAIGN_OBJECTIVE = "Campaign Objective",
  CAMPAIGN_TYPE = "Campaign Type",
  CHANNEL = "Channel",
  DAILY = "Daily",
  DEVICE = "Device",
  MONTHLY = "Monthly",
  PRODUCT = "Product",
  SOURCE_MEDIUM = "Source / Medium",
  WEEKLY = "Weekly",
  STORE_ID = "Store ID",
  AD_ACCOUNT_ID = "Ad Account ID",
  INDUSTRY = "Industry",
  AOV = "AOV Bucket",
  SPEND = "Spend Bucket",
}

export const PINNABLE_METRICS: MetricTypes[] = [
  MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_PLUS_SHIPPING_PLUS_TAX,
  MetricTypes.GOOGLE_AD_SPEND,
  MetricTypes.GOOGLE_AD_ATTRIBUTED_CONVERSION_ROAS,
  MetricTypes.META_AD_SPEND,
  MetricTypes.META_AD_ATTRIBUTED_CONVERSION_ROAS,
  MetricTypes.TOTAL_ORDER_QUANTITY,
  MetricTypes.AVERAGE_UNITS_PER_ORDER,
  MetricTypes.TOTAL_ORDERED_ITEM_QUANTITY,
  MetricTypes.AOV,
  MetricTypes.ROAS,
  MetricTypes.ITEM_LEVEL_NEW_CUSTOMER_PERCENT_FROM_PRODUCTS,
  MetricTypes.ITEM_LEVEL_NEW_CUSTOMER_PERCENT,
  MetricTypes.RETURNING_CUSTOMER_PERCENTAGE,
  MetricTypes.ITEM_LEVEL_RETURN_RATE_FROM_PRODUCTS,
  MetricTypes.ITEM_LEVEL_RETURN_RATE_FROM_REFUNDS,
  MetricTypes.SESSION_COUNT,
  MetricTypes.CONVERSION_RATE,
  MetricTypes.TIKTOK_AD_SPEND,
];

export const getMetricOverrideFromMetricType = (metric: MetricTypes, currencyCode: string) => {
  return {
    [MetricTypes.PERCENT_OF_TOTAL_REVENUE]: {
      name: MetricTypes.PERCENT_OF_TOTAL_REVENUE,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.PERCENT_OF_TOTAL_SPEND]: {
      name: MetricTypes.PERCENT_OF_TOTAL_SPEND,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.AOV]: {
      name: MetricTypes.AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.ACTIVE_CAMPAIGNS]: {
      name: MetricTypes.ACTIVE_CAMPAIGNS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.AD_PLATFORM_REPORTED_REVENUE]: {
      name: MetricTypes.AD_PLATFORM_REPORTED_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.ALL_TIME_REVENUE]: {
      name: MetricTypes.ALL_TIME_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.ALL_TIME_SPEND]: {
      name: MetricTypes.ALL_TIME_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.CAC]: {
      name: MetricTypes.CAC,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.CUSTOMERS]: {
      name: MetricTypes.CUSTOMERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.CUSTOMERS_EXISTING]: {
      name: MetricTypes.CUSTOMERS_EXISTING,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.CUSTOMERS_NEW]: {
      name: MetricTypes.CUSTOMERS_NEW,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.CUSTOMERS_NEW_PERCENTAGE]: {
      name: MetricTypes.CUSTOMERS_NEW_PERCENTAGE,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.CUSTOMERS_TOTAL]: {
      name: MetricTypes.CUSTOMERS_TOTAL,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.DISCOUNTS]: {
      name: MetricTypes.DISCOUNTS,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.AD_ADDED_TO_CART]: {
      name: MetricTypes.AD_ADDED_TO_CART,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.AD_CLICKS]: {
      name: MetricTypes.AD_CLICKS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.AD_FREQUENCY]: {
      name: MetricTypes.AD_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.AD_IMPRESSIONS]: {
      name: MetricTypes.AD_IMPRESSIONS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.AD_REACH]: {
      name: MetricTypes.AD_REACH,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.AD_SPEND]: {
      name: MetricTypes.AD_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.AD_VIEWS]: {
      name: MetricTypes.AD_VIEWS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.AD_CTR]: {
      name: MetricTypes.AD_CTR,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.AD_AOV]: {
      name: MetricTypes.AD_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.AD_CONVERSION_RATE]: {
      name: MetricTypes.AD_CONVERSION_RATE,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.AD_COST_PER_CONVERSION]: {
      name: MetricTypes.AD_COST_PER_CONVERSION,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.AD_COST_PER_IMPRESSION]: {
      name: MetricTypes.AD_COST_PER_IMPRESSION,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.AD_COST_PER_CLICK]: {
      name: MetricTypes.AD_COST_PER_CLICK,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.AD_ATTRIBUTED_CONVERSION_ROAS]: {
      name: MetricTypes.AD_ATTRIBUTED_CONVERSION_ROAS,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.AD_ATTRIBUTED_CONVERSION_VALUE]: {
      name: MetricTypes.AD_ATTRIBUTED_CONVERSION_VALUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.AD_ATTRIBUTED_CONVERSION_COUNT]: {
      name: MetricTypes.AD_ATTRIBUTED_CONVERSION_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.MARKETING_EFFICIENCY_RATIO]: {
      name: MetricTypes.MARKETING_EFFICIENCY_RATIO,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.ACQUISITION_MARKETING_EFFICIENCY_RATIO]: {
      name: MetricTypes.ACQUISITION_MARKETING_EFFICIENCY_RATIO,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.BLENDED_AD_CLICKS]: {
      name: MetricTypes.BLENDED_AD_CLICKS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.BLENDED_AD_FREQUENCY]: {
      name: MetricTypes.BLENDED_AD_FREQUENCY,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.BLENDED_AD_IMPRESSIONS]: {
      name: MetricTypes.BLENDED_AD_IMPRESSIONS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.BLENDED_AD_REACH]: {
      name: MetricTypes.BLENDED_AD_REACH,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.BLENDED_AD_SPEND]: {
      name: MetricTypes.BLENDED_AD_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.BLENDED_AD_VIEWS]: {
      name: MetricTypes.BLENDED_AD_VIEWS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.BLENDED_AD_CTR]: {
      name: MetricTypes.BLENDED_AD_CTR,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.BLENDED_AD_AOV]: {
      name: MetricTypes.BLENDED_AD_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.BLENDED_AD_CONVERSION_RATE]: {
      name: MetricTypes.BLENDED_AD_CONVERSION_RATE,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.BLENDED_AD_COST_PER_CONVERSION]: {
      name: MetricTypes.BLENDED_AD_COST_PER_CONVERSION,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.BLENDED_AD_COST_PER_IMPRESSION]: {
      name: MetricTypes.BLENDED_AD_COST_PER_IMPRESSION,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.BLENDED_AD_COST_PER_CLICK]: {
      name: MetricTypes.BLENDED_AD_COST_PER_CLICK,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.BLENDED_AD_ATTRIBUTED_CONVERSION_COUNT]: {
      name: MetricTypes.BLENDED_AD_ATTRIBUTED_CONVERSION_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.BLENDED_AD_ATTRIBUTED_CONVERSION_VALUE]: {
      name: MetricTypes.BLENDED_AD_ATTRIBUTED_CONVERSION_VALUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.BLENDED_AD_ATTRIBUTED_CONVERSION_ROAS]: {
      name: MetricTypes.BLENDED_AD_ATTRIBUTED_CONVERSION_ROAS,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.BLENDED_AD_RELATIVE_PERCENTAGE_SPEND]: {
      name: MetricTypes.BLENDED_AD_RELATIVE_PERCENTAGE_SPEND,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.META_AD_ADDED_TO_CART]: {
      name: MetricTypes.META_AD_ADDED_TO_CART,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.META_AD_CLICKS]: {
      name: MetricTypes.META_AD_CLICKS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.META_AD_FREQUENCY]: {
      name: MetricTypes.META_AD_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.META_AD_IMPRESSIONS]: {
      name: MetricTypes.META_AD_IMPRESSIONS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.META_AD_REACH]: {
      name: MetricTypes.META_AD_REACH,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.META_AD_SPEND]: {
      name: MetricTypes.META_AD_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.META_AD_VIEWS]: {
      name: MetricTypes.META_AD_VIEWS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.META_AD_CTR]: {
      name: MetricTypes.META_AD_CTR,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.META_AD_AOV]: {
      name: MetricTypes.META_AD_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.META_AD_CONVERSION_RATE]: {
      name: MetricTypes.META_AD_CONVERSION_RATE,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.META_AD_COST_PER_CONVERSION]: {
      name: MetricTypes.META_AD_COST_PER_CONVERSION,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.META_AD_COST_PER_IMPRESSION]: {
      name: MetricTypes.META_AD_COST_PER_IMPRESSION,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.META_AD_COST_PER_MILLE]: {
      name: MetricTypes.META_AD_COST_PER_MILLE,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.META_AD_COST_PER_CLICK]: {
      name: MetricTypes.META_AD_COST_PER_CLICK,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.META_AD_ATTRIBUTED_CONVERSION_COUNT]: {
      name: MetricTypes.META_AD_ATTRIBUTED_CONVERSION_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.META_AD_ATTRIBUTED_CONVERSION_VALUE]: {
      name: MetricTypes.META_AD_ATTRIBUTED_CONVERSION_VALUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.META_AD_ATTRIBUTED_CONVERSION_ROAS]: {
      name: MetricTypes.META_AD_ATTRIBUTED_CONVERSION_ROAS,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.META_AD_RELATIVE_PERCENTAGE_SPEND]: {
      name: MetricTypes.META_AD_RELATIVE_PERCENTAGE_SPEND,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.GOOGLE_AD_CLICKS]: {
      name: MetricTypes.GOOGLE_AD_CLICKS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.GOOGLE_AD_FREQUENCY]: {
      name: MetricTypes.GOOGLE_AD_FREQUENCY,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.GOOGLE_AD_IMPRESSIONS]: {
      name: MetricTypes.GOOGLE_AD_IMPRESSIONS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.GOOGLE_AD_REACH]: {
      name: MetricTypes.GOOGLE_AD_REACH,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.GOOGLE_AD_SPEND]: {
      name: MetricTypes.GOOGLE_AD_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.GOOGLE_AD_VIEWS]: {
      name: MetricTypes.GOOGLE_AD_VIEWS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.GOOGLE_AD_CTR]: {
      name: MetricTypes.GOOGLE_AD_CTR,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.GOOGLE_AD_AOV]: {
      name: MetricTypes.GOOGLE_AD_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.GOOGLE_AD_CONVERSION_RATE]: {
      name: MetricTypes.GOOGLE_AD_CONVERSION_RATE,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.GOOGLE_AD_COST_PER_CONVERSION]: {
      name: MetricTypes.GOOGLE_AD_COST_PER_CONVERSION,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.GOOGLE_AD_COST_PER_IMPRESSION]: {
      name: MetricTypes.GOOGLE_AD_COST_PER_IMPRESSION,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.GOOGLE_AD_COST_PER_CLICK]: {
      name: MetricTypes.GOOGLE_AD_COST_PER_CLICK,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.GOOGLE_AD_ATTRIBUTED_CONVERSION_COUNT]: {
      name: MetricTypes.GOOGLE_AD_ATTRIBUTED_CONVERSION_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.GOOGLE_AD_ATTRIBUTED_CONVERSION_VALUE]: {
      name: MetricTypes.GOOGLE_AD_ATTRIBUTED_CONVERSION_VALUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.GOOGLE_AD_ATTRIBUTED_CONVERSION_ROAS]: {
      name: MetricTypes.GOOGLE_AD_ATTRIBUTED_CONVERSION_ROAS,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.GOOGLE_AD_RELATIVE_PERCENTAGE_SPEND]: {
      name: MetricTypes.GOOGLE_AD_RELATIVE_PERCENTAGE_SPEND,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.TIKTOK_AD_SPEND]: {
      name: MetricTypes.TIKTOK_AD_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TIKTOK_ACCOUNT_ID]: {
      name: MetricTypes.TIKTOK_ACCOUNT_ID,
      type: "STRING",
      success_direction: "up",
    },
    [MetricTypes.TIKTOK_ACCOUNT_NAME]: {
      name: MetricTypes.TIKTOK_ACCOUNT_NAME,
      type: "STRING",
      success_direction: "up",
    },
    [MetricTypes.TIKTOK_WAYFLYER_BC_ID]: {
      name: MetricTypes.TIKTOK_WAYFLYER_BC_ID,
      type: "STRING",
      success_direction: "up",
    },
    [MetricTypes.GROSS_ITEM_QUANTITY]: {
      name: MetricTypes.GROSS_ITEM_QUANTITY,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.GROSS_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_PRODUCTS]: {
      name: MetricTypes.GROSS_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_PRODUCTS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.GROSS_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_REFUNDS]: {
      name: MetricTypes.GROSS_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_REFUNDS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.GROSS_PRODUCT_REVENUE_FROM_ORDER_PROPORTION_LESS_DISCOUNTS]: {
      name: MetricTypes.GROSS_PRODUCT_REVENUE_FROM_ORDER_PROPORTION_LESS_DISCOUNTS,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.GROSS_PRODUCT_REVENUE_FROM_ORDER_PROPORTION_LESS_DISCOUNTS_LESS_REFUNDED_AMOUNT_FROM_ORDERS]: {
      name: MetricTypes.GROSS_PRODUCT_REVENUE_FROM_ORDER_PROPORTION_LESS_DISCOUNTS_LESS_REFUNDED_AMOUNT_FROM_ORDERS,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.GROSS_PRODUCT_REVENUE_FROM_ORDER_PROPORTION_LESS_DISCOUNTS_LESS_REFUNDED_AMOUNT_FROM_REFUNDS]: {
      name: MetricTypes.GROSS_PRODUCT_REVENUE_FROM_ORDER_PROPORTION_LESS_DISCOUNTS_LESS_REFUNDED_AMOUNT_FROM_REFUNDS,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_LESS_REFUNDS_BY_REFUNDED_DATE_PLUS_SHIPPING_PLUS_TAX]: {
      name: MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_LESS_REFUNDS_BY_REFUNDED_DATE_PLUS_SHIPPING_PLUS_TAX,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_LESS_REFUNDS_FROM_ORDERS_PLUS_SHIPPING_PLUS_TAX]: {
      name: MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_LESS_REFUNDS_FROM_ORDERS_PLUS_SHIPPING_PLUS_TAX,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_LESS_REFUNDS_PLUS_SHIPPING_PLUS_TAX]: {
      name: MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_LESS_REFUNDS_PLUS_SHIPPING_PLUS_TAX,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_PLUS_SHIPPING_PLUS_TAX]: {
      name: MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_PLUS_SHIPPING_PLUS_TAX,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.ACQUISITION_GROSS_REVENUE_LESS_DISCOUNTS_PLUS_SHIPPING_PLUS_TAX]: {
      name: MetricTypes.ACQUISITION_GROSS_REVENUE_LESS_DISCOUNTS_PLUS_SHIPPING_PLUS_TAX,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.GROSS_REVENUE]: {
      name: MetricTypes.GROSS_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.NEW_CUSTOMER_ITEM_QUANTITY]: {
      name: MetricTypes.NEW_CUSTOMER_ITEM_QUANTITY,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.NEW_CUSTOMER_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_PRODUCTS]: {
      name: MetricTypes.NEW_CUSTOMER_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_PRODUCTS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.ITEM_LEVEL_NEW_CUSTOMER_PERCENT]: {
      name: MetricTypes.ITEM_LEVEL_NEW_CUSTOMER_PERCENT,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.ITEM_LEVEL_NEW_CUSTOMER_PERCENT_FROM_PRODUCTS]: {
      name: MetricTypes.ITEM_LEVEL_NEW_CUSTOMER_PERCENT_FROM_PRODUCTS,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.ITEM_LEVEL_RETURN_RATE_FROM_PRODUCTS]: {
      name: MetricTypes.ITEM_LEVEL_RETURN_RATE_FROM_PRODUCTS,
      type: "PERCENTAGE",
      success_direction: "down",
    },
    [MetricTypes.ITEM_LEVEL_RETURN_RATE_FROM_REFUNDS]: {
      name: MetricTypes.ITEM_LEVEL_RETURN_RATE_FROM_REFUNDS,
      type: "PERCENTAGE",
      success_direction: "down",
    },
    [MetricTypes.RETURNING_CUSTOMER_PERCENTAGE]: {
      name: MetricTypes.RETURNING_CUSTOMER_PERCENTAGE,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.LTV]: {
      name: MetricTypes.LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.LINK_CLICKS]: {
      name: MetricTypes.LINK_CLICKS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.MARKETING_SPEND]: {
      name: MetricTypes.MARKETING_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.LTV_CAC_MONTH]: {
      name: MetricTypes.LTV_CAC_MONTH,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.MONTH_FIRST_ORDER]: {
      name: MetricTypes.MONTH_FIRST_ORDER,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.NET_QUANTITY]: {
      name: MetricTypes.NET_QUANTITY,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.NET_REVENUE]: {
      name: MetricTypes.NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.NET_SALES_EXISTING]: {
      name: MetricTypes.NET_SALES_EXISTING,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.NET_SALES_NEW]: {
      name: MetricTypes.NET_SALES_NEW,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.NET_SALES_NEW_PERCENTAGE]: {
      name: MetricTypes.NET_SALES_NEW_PERCENTAGE,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.NET_SALES_TOTAL]: {
      name: MetricTypes.NET_SALES_TOTAL,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.NEW_CUSTOMERS]: {
      name: MetricTypes.NEW_CUSTOMERS,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.ORDERS]: {
      name: MetricTypes.ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.ORDERS_EXISTING]: {
      name: MetricTypes.ORDERS_EXISTING,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.ORDERS_NEW]: {
      name: MetricTypes.ORDERS_NEW,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.ORDERS_NEW_PERCENTAGE]: {
      name: MetricTypes.ORDERS_NEW_PERCENTAGE,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.ORDERS_TOTAL]: {
      name: MetricTypes.ORDERS_TOTAL,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.PRODUCT_QUANTITY]: {
      name: MetricTypes.PRODUCT_QUANTITY,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.PRODUCT_REFUNDS_FROM_PRODUCTS]: {
      name: MetricTypes.PRODUCT_REFUNDS_FROM_PRODUCTS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.PRODUCT_REFUNDS_FROM_REFUNDS]: {
      name: MetricTypes.PRODUCT_REFUNDS_FROM_REFUNDS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.QUANTITY]: {
      name: MetricTypes.QUANTITY,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.LTV_CAC_QUARTER]: {
      name: MetricTypes.LTV_CAC_QUARTER,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.QUARTER_FIRST_ORDER]: {
      name: MetricTypes.QUARTER_FIRST_ORDER,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.ROAS]: {
      name: MetricTypes.ROAS,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.REFUNDS_PERCENT]: {
      name: MetricTypes.REFUNDS_PERCENT,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.RETURN_RATE]: {
      name: MetricTypes.RETURN_RATE,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.RETURNS]: {
      name: MetricTypes.RETURNS,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.REVENUE]: {
      name: MetricTypes.REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SALES]: {
      name: MetricTypes.SALES,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SALES_EXISTING]: {
      name: MetricTypes.SALES_EXISTING,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SALES_NEW]: {
      name: MetricTypes.SALES_NEW,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SALES_NEW_PERCENTAGE]: {
      name: MetricTypes.SALES_NEW_PERCENTAGE,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.SALES_TOTAL]: {
      name: MetricTypes.SALES_TOTAL,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SALES_EXCLUDING_REFUNDS]: {
      name: MetricTypes.SALES_EXCLUDING_REFUNDS,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TOTAL_ORDERED_ITEM_QUANTITY]: {
      name: MetricTypes.TOTAL_ORDERED_ITEM_QUANTITY,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TOTAL_ORDERED_ITEM_QUANTITY_LESS_REFUNDED_ITEM_QUANTITY]: {
      name: MetricTypes.TOTAL_ORDERED_ITEM_QUANTITY_LESS_REFUNDED_ITEM_QUANTITY,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TOTAL_ORDERED_ITEM_QUANTITY_LESS_REFUNDED_ITEM_QUANTITY_BY_REFUNDED_DATE]: {
      name: MetricTypes.TOTAL_ORDERED_ITEM_QUANTITY_LESS_REFUNDED_ITEM_QUANTITY_BY_REFUNDED_DATE,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TOTAL_ORDER_QUANTITY]: {
      name: MetricTypes.TOTAL_ORDER_QUANTITY,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TOTAL_REFUNDED_ITEM_QUANTITY]: {
      name: MetricTypes.TOTAL_REFUNDED_ITEM_QUANTITY,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TOTAL_REFUNDED_ITEM_QUANTITY_BY_REFUNDED_DATE]: {
      name: MetricTypes.TOTAL_REFUNDED_ITEM_QUANTITY_BY_REFUNDED_DATE,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TOTAL_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.TOTAL_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TOTAL_UNIQUE_NEW_CUSTOMER_COUNT]: {
      name: MetricTypes.TOTAL_UNIQUE_NEW_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TOTAL_SALES]: {
      name: MetricTypes.TOTAL_SALES,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TRANSACTIONS]: {
      name: MetricTypes.TRANSACTIONS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.LTV_CAC_YEAR]: {
      name: MetricTypes.LTV_CAC_YEAR,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.YEAR_FIRST_ORDER]: {
      name: MetricTypes.YEAR_FIRST_ORDER,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.ADDITIONAL_COGS_AND_SHIPPING]: {
      name: MetricTypes.ADDITIONAL_COGS_AND_SHIPPING,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.ADDITIONAL_OPEX]: {
      name: MetricTypes.ADDITIONAL_OPEX,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.COGS]: {
      name: MetricTypes.COGS,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.GROSS_PROFIT]: {
      name: MetricTypes.GROSS_PROFIT,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.GROSS_MARGIN_PERCENTAGE]: {
      name: MetricTypes.GROSS_MARGIN_PERCENTAGE,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.FCP]: {
      name: MetricTypes.FCP,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TEST_METRIC]: {
      name: MetricTypes.TEST_METRIC,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.PROFIT]: {
      name: MetricTypes.PROFIT,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.PERCENTAGE_OF_SPEND]: {
      name: MetricTypes.PERCENTAGE_OF_SPEND,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.PERCENTAGE_OF_TOTAL_AD_SPEND]: {
      name: MetricTypes.PERCENTAGE_OF_TOTAL_AD_SPEND,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.AVERAGE_UNITS_PER_ORDER]: {
      name: MetricTypes.AVERAGE_UNITS_PER_ORDER,
      type: "DECIMAL",
      success_direction: "up",
    },
    [MetricTypes.REFUNDED_ITEM_PERCENTAGE]: {
      name: MetricTypes.REFUNDED_ITEM_PERCENTAGE,
      type: "PERCENTAGE",
      success_direction: "down",
    },
    [MetricTypes.REFUNDED_ITEM_PERCENTAGE_BY_REFUNDED_DATE]: {
      name: MetricTypes.REFUNDED_ITEM_PERCENTAGE_BY_REFUNDED_DATE,
      type: "PERCENTAGE",
      success_direction: "down",
    },
    [MetricTypes.AVERAGE_DAILY_UNITS]: {
      name: MetricTypes.AVERAGE_DAILY_UNITS,
      type: "DECIMAL",
      success_direction: "up",
    },
    [MetricTypes.SALES_VELOCITY_THIRTY_DAYS]: {
      name: MetricTypes.SALES_VELOCITY_THIRTY_DAYS,
      type: "DECIMAL",
      success_direction: "up",
    },
    [MetricTypes.GROSS_PRODUCT_REVENUE]: {
      name: MetricTypes.GROSS_PRODUCT_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.PRODUCT_LEVEL_DISCOUNT_PCT]: {
      name: MetricTypes.PRODUCT_LEVEL_DISCOUNT_PCT,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.PRODUCT_LEVEL_DISCOUNT_VALUE]: {
      name: MetricTypes.PRODUCT_LEVEL_DISCOUNT_VALUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SESSION_COUNT]: {
      name: MetricTypes.SESSION_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.CONVERSION_RATE]: {
      name: MetricTypes.CONVERSION_RATE,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.STORE_NAME]: {
      name: MetricTypes.STORE_NAME,
      type: "STRING",
      success_direction: "up",
    },
    [MetricTypes.ALLTIME_AOV]: {
      name: MetricTypes.ALLTIME_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.ALLTIME_FREQUENCY]: {
      name: MetricTypes.ALLTIME_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.ALLTIME_LTV]: {
      name: MetricTypes.ALLTIME_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.ALLTIME_NET_REVENUE]: {
      name: MetricTypes.ALLTIME_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.ALLTIME_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.ALLTIME_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.ALLTIME_ORDERS]: {
      name: MetricTypes.ALLTIME_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.ALLTIME_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.ALLTIME_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.ALLTIME_CAC]: {
      name: MetricTypes.ALLTIME_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SAME_MONTH_AOV]: {
      name: MetricTypes.SAME_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SAME_MONTH_FREQUENCY]: {
      name: MetricTypes.SAME_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.SAME_MONTH_LTV]: {
      name: MetricTypes.SAME_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SAME_MONTH_NET_REVENUE]: {
      name: MetricTypes.SAME_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SAME_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.SAME_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.SAME_MONTH_ORDERS]: {
      name: MetricTypes.SAME_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.SAME_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.SAME_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SAME_MONTH_CAC]: {
      name: MetricTypes.SAME_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.ONE_MONTH_AOV]: {
      name: MetricTypes.ONE_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.ONE_MONTH_FREQUENCY]: {
      name: MetricTypes.ONE_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.ONE_MONTH_LTV]: {
      name: MetricTypes.ONE_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.ONE_MONTH_NET_REVENUE]: {
      name: MetricTypes.ONE_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.ONE_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.ONE_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.ONE_MONTH_ORDERS]: {
      name: MetricTypes.ONE_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.ONE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.ONE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.ONE_MONTH_CAC]: {
      name: MetricTypes.ONE_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWO_MONTH_AOV]: {
      name: MetricTypes.TWO_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWO_MONTH_FREQUENCY]: {
      name: MetricTypes.TWO_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.TWO_MONTH_LTV]: {
      name: MetricTypes.TWO_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWO_MONTH_NET_REVENUE]: {
      name: MetricTypes.TWO_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWO_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.TWO_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TWO_MONTH_ORDERS]: {
      name: MetricTypes.TWO_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TWO_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.TWO_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWO_MONTH_CAC]: {
      name: MetricTypes.TWO_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.THREE_MONTH_AOV]: {
      name: MetricTypes.THREE_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.THREE_MONTH_FREQUENCY]: {
      name: MetricTypes.THREE_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.THREE_MONTH_LTV]: {
      name: MetricTypes.THREE_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.THREE_MONTH_NET_REVENUE]: {
      name: MetricTypes.THREE_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.THREE_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.THREE_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.THREE_MONTH_ORDERS]: {
      name: MetricTypes.THREE_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.THREE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.THREE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.THREE_MONTH_CAC]: {
      name: MetricTypes.THREE_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FOUR_MONTH_AOV]: {
      name: MetricTypes.FOUR_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FOUR_MONTH_FREQUENCY]: {
      name: MetricTypes.FOUR_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.FOUR_MONTH_LTV]: {
      name: MetricTypes.FOUR_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FOUR_MONTH_NET_REVENUE]: {
      name: MetricTypes.FOUR_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FOUR_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.FOUR_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.FOUR_MONTH_ORDERS]: {
      name: MetricTypes.FOUR_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.FOUR_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.FOUR_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FOUR_MONTH_CAC]: {
      name: MetricTypes.FOUR_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FIVE_MONTH_AOV]: {
      name: MetricTypes.FIVE_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FIVE_MONTH_FREQUENCY]: {
      name: MetricTypes.FIVE_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.FIVE_MONTH_LTV]: {
      name: MetricTypes.FIVE_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FIVE_MONTH_NET_REVENUE]: {
      name: MetricTypes.FIVE_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FIVE_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.FIVE_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.FIVE_MONTH_ORDERS]: {
      name: MetricTypes.FIVE_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.FIVE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.FIVE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FIVE_MONTH_CAC]: {
      name: MetricTypes.FIVE_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SIX_MONTH_AOV]: {
      name: MetricTypes.SIX_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SIX_MONTH_FREQUENCY]: {
      name: MetricTypes.SIX_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.SIX_MONTH_LTV]: {
      name: MetricTypes.SIX_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SIX_MONTH_NET_REVENUE]: {
      name: MetricTypes.SIX_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SIX_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.SIX_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.SIX_MONTH_ORDERS]: {
      name: MetricTypes.SIX_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.SIX_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.SIX_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SIX_MONTH_CAC]: {
      name: MetricTypes.SIX_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SEVEN_MONTH_AOV]: {
      name: MetricTypes.SEVEN_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SEVEN_MONTH_FREQUENCY]: {
      name: MetricTypes.SEVEN_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.SEVEN_MONTH_LTV]: {
      name: MetricTypes.SEVEN_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SEVEN_MONTH_NET_REVENUE]: {
      name: MetricTypes.SEVEN_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SEVEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.SEVEN_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.SEVEN_MONTH_ORDERS]: {
      name: MetricTypes.SEVEN_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.SEVEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.SEVEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SEVEN_MONTH_CAC]: {
      name: MetricTypes.SEVEN_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.EIGHT_MONTH_AOV]: {
      name: MetricTypes.EIGHT_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.EIGHT_MONTH_FREQUENCY]: {
      name: MetricTypes.EIGHT_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.EIGHT_MONTH_LTV]: {
      name: MetricTypes.EIGHT_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.EIGHT_MONTH_NET_REVENUE]: {
      name: MetricTypes.EIGHT_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.EIGHT_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.EIGHT_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.EIGHT_MONTH_ORDERS]: {
      name: MetricTypes.EIGHT_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.EIGHT_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.EIGHT_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.EIGHT_MONTH_CAC]: {
      name: MetricTypes.EIGHT_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.NINE_MONTH_AOV]: {
      name: MetricTypes.NINE_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.NINE_MONTH_FREQUENCY]: {
      name: MetricTypes.NINE_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.NINE_MONTH_LTV]: {
      name: MetricTypes.NINE_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.NINE_MONTH_NET_REVENUE]: {
      name: MetricTypes.NINE_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.NINE_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.NINE_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.NINE_MONTH_ORDERS]: {
      name: MetricTypes.NINE_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.NINE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.NINE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.NINE_MONTH_CAC]: {
      name: MetricTypes.NINE_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TEN_MONTH_AOV]: {
      name: MetricTypes.TEN_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TEN_MONTH_FREQUENCY]: {
      name: MetricTypes.TEN_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.TEN_MONTH_LTV]: {
      name: MetricTypes.TEN_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TEN_MONTH_NET_REVENUE]: {
      name: MetricTypes.TEN_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.TEN_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TEN_MONTH_ORDERS]: {
      name: MetricTypes.TEN_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.TEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TEN_MONTH_CAC]: {
      name: MetricTypes.TEN_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.ELEVEN_MONTH_AOV]: {
      name: MetricTypes.ELEVEN_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.ELEVEN_MONTH_FREQUENCY]: {
      name: MetricTypes.ELEVEN_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.ELEVEN_MONTH_LTV]: {
      name: MetricTypes.ELEVEN_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.ELEVEN_MONTH_NET_REVENUE]: {
      name: MetricTypes.ELEVEN_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.ELEVEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.ELEVEN_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.ELEVEN_MONTH_ORDERS]: {
      name: MetricTypes.ELEVEN_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.ELEVEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.ELEVEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.ELEVEN_MONTH_CAC]: {
      name: MetricTypes.ELEVEN_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWELVE_MONTH_AOV]: {
      name: MetricTypes.TWELVE_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWELVE_MONTH_FREQUENCY]: {
      name: MetricTypes.TWELVE_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.TWELVE_MONTH_LTV]: {
      name: MetricTypes.TWELVE_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWELVE_MONTH_NET_REVENUE]: {
      name: MetricTypes.TWELVE_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWELVE_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.TWELVE_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TWELVE_MONTH_ORDERS]: {
      name: MetricTypes.TWELVE_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TWELVE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.TWELVE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWELVE_MONTH_CAC]: {
      name: MetricTypes.TWELVE_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.THIRTEEN_MONTH_AOV]: {
      name: MetricTypes.THIRTEEN_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.THIRTEEN_MONTH_FREQUENCY]: {
      name: MetricTypes.THIRTEEN_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.THIRTEEN_MONTH_LTV]: {
      name: MetricTypes.THIRTEEN_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.THIRTEEN_MONTH_NET_REVENUE]: {
      name: MetricTypes.THIRTEEN_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.THIRTEEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.THIRTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.THIRTEEN_MONTH_ORDERS]: {
      name: MetricTypes.THIRTEEN_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.THIRTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.THIRTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.THIRTEEN_MONTH_CAC]: {
      name: MetricTypes.THIRTEEN_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FOURTEEN_MONTH_AOV]: {
      name: MetricTypes.FOURTEEN_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FOURTEEN_MONTH_FREQUENCY]: {
      name: MetricTypes.FOURTEEN_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.FOURTEEN_MONTH_LTV]: {
      name: MetricTypes.FOURTEEN_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FOURTEEN_MONTH_NET_REVENUE]: {
      name: MetricTypes.FOURTEEN_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FOURTEEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.FOURTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.FOURTEEN_MONTH_ORDERS]: {
      name: MetricTypes.FOURTEEN_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.FOURTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.FOURTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FOURTEEN_MONTH_CAC]: {
      name: MetricTypes.FOURTEEN_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FIFTEEN_MONTH_AOV]: {
      name: MetricTypes.FIFTEEN_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FIFTEEN_MONTH_FREQUENCY]: {
      name: MetricTypes.FIFTEEN_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.FIFTEEN_MONTH_LTV]: {
      name: MetricTypes.FIFTEEN_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FIFTEEN_MONTH_NET_REVENUE]: {
      name: MetricTypes.FIFTEEN_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FIFTEEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.FIFTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.FIFTEEN_MONTH_ORDERS]: {
      name: MetricTypes.FIFTEEN_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.FIFTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.FIFTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.FIFTEEN_MONTH_CAC]: {
      name: MetricTypes.FIFTEEN_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SIXTEEN_MONTH_AOV]: {
      name: MetricTypes.SIXTEEN_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SIXTEEN_MONTH_FREQUENCY]: {
      name: MetricTypes.SIXTEEN_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.SIXTEEN_MONTH_LTV]: {
      name: MetricTypes.SIXTEEN_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SIXTEEN_MONTH_NET_REVENUE]: {
      name: MetricTypes.SIXTEEN_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SIXTEEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.SIXTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.SIXTEEN_MONTH_ORDERS]: {
      name: MetricTypes.SIXTEEN_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.SIXTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.SIXTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SIXTEEN_MONTH_CAC]: {
      name: MetricTypes.SIXTEEN_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SEVENTEEN_MONTH_AOV]: {
      name: MetricTypes.SEVENTEEN_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SEVENTEEN_MONTH_FREQUENCY]: {
      name: MetricTypes.SEVENTEEN_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.SEVENTEEN_MONTH_LTV]: {
      name: MetricTypes.SEVENTEEN_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SEVENTEEN_MONTH_NET_REVENUE]: {
      name: MetricTypes.SEVENTEEN_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SEVENTEEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.SEVENTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.SEVENTEEN_MONTH_ORDERS]: {
      name: MetricTypes.SEVENTEEN_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.SEVENTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.SEVENTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.SEVENTEEN_MONTH_CAC]: {
      name: MetricTypes.SEVENTEEN_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.EIGHTEEN_MONTH_AOV]: {
      name: MetricTypes.EIGHTEEN_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.EIGHTEEN_MONTH_FREQUENCY]: {
      name: MetricTypes.EIGHTEEN_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.EIGHTEEN_MONTH_LTV]: {
      name: MetricTypes.EIGHTEEN_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.EIGHTEEN_MONTH_NET_REVENUE]: {
      name: MetricTypes.EIGHTEEN_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.EIGHTEEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.EIGHTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.EIGHTEEN_MONTH_ORDERS]: {
      name: MetricTypes.EIGHTEEN_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.EIGHTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.EIGHTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.EIGHTEEN_MONTH_CAC]: {
      name: MetricTypes.EIGHTEEN_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.NINETEEN_MONTH_AOV]: {
      name: MetricTypes.NINETEEN_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.NINETEEN_MONTH_FREQUENCY]: {
      name: MetricTypes.NINETEEN_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.NINETEEN_MONTH_LTV]: {
      name: MetricTypes.NINETEEN_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.NINETEEN_MONTH_NET_REVENUE]: {
      name: MetricTypes.NINETEEN_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.NINETEEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.NINETEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.NINETEEN_MONTH_ORDERS]: {
      name: MetricTypes.NINETEEN_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.NINETEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.NINETEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.NINETEEN_MONTH_CAC]: {
      name: MetricTypes.NINETEEN_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_MONTH_AOV]: {
      name: MetricTypes.TWENTY_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_MONTH_FREQUENCY]: {
      name: MetricTypes.TWENTY_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.TWENTY_MONTH_LTV]: {
      name: MetricTypes.TWENTY_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_MONTH_NET_REVENUE]: {
      name: MetricTypes.TWENTY_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.TWENTY_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TWENTY_MONTH_ORDERS]: {
      name: MetricTypes.TWENTY_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TWENTY_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.TWENTY_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_MONTH_CAC]: {
      name: MetricTypes.TWENTY_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_ONE_MONTH_AOV]: {
      name: MetricTypes.TWENTY_ONE_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_ONE_MONTH_FREQUENCY]: {
      name: MetricTypes.TWENTY_ONE_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.TWENTY_ONE_MONTH_LTV]: {
      name: MetricTypes.TWENTY_ONE_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_ONE_MONTH_NET_REVENUE]: {
      name: MetricTypes.TWENTY_ONE_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_ONE_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.TWENTY_ONE_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TWENTY_ONE_MONTH_ORDERS]: {
      name: MetricTypes.TWENTY_ONE_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TWENTY_ONE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.TWENTY_ONE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_ONE_MONTH_CAC]: {
      name: MetricTypes.TWENTY_ONE_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_TWO_MONTH_AOV]: {
      name: MetricTypes.TWENTY_TWO_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_TWO_MONTH_FREQUENCY]: {
      name: MetricTypes.TWENTY_TWO_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.TWENTY_TWO_MONTH_LTV]: {
      name: MetricTypes.TWENTY_TWO_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_TWO_MONTH_NET_REVENUE]: {
      name: MetricTypes.TWENTY_TWO_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_TWO_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.TWENTY_TWO_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TWENTY_TWO_MONTH_ORDERS]: {
      name: MetricTypes.TWENTY_TWO_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TWENTY_TWO_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.TWENTY_TWO_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_TWO_MONTH_CAC]: {
      name: MetricTypes.TWENTY_TWO_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_THREE_MONTH_AOV]: {
      name: MetricTypes.TWENTY_THREE_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_THREE_MONTH_FREQUENCY]: {
      name: MetricTypes.TWENTY_THREE_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.TWENTY_THREE_MONTH_LTV]: {
      name: MetricTypes.TWENTY_THREE_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_THREE_MONTH_NET_REVENUE]: {
      name: MetricTypes.TWENTY_THREE_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_THREE_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.TWENTY_THREE_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TWENTY_THREE_MONTH_ORDERS]: {
      name: MetricTypes.TWENTY_THREE_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TWENTY_THREE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.TWENTY_THREE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_THREE_MONTH_CAC]: {
      name: MetricTypes.TWENTY_THREE_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_FOUR_MONTH_AOV]: {
      name: MetricTypes.TWENTY_FOUR_MONTH_AOV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_FOUR_MONTH_FREQUENCY]: {
      name: MetricTypes.TWENTY_FOUR_MONTH_FREQUENCY,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.TWENTY_FOUR_MONTH_LTV]: {
      name: MetricTypes.TWENTY_FOUR_MONTH_LTV,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_FOUR_MONTH_NET_REVENUE]: {
      name: MetricTypes.TWENTY_FOUR_MONTH_NET_REVENUE,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_FOUR_MONTH_UNIQUE_CUSTOMER_COUNT]: {
      name: MetricTypes.TWENTY_FOUR_MONTH_UNIQUE_CUSTOMER_COUNT,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TWENTY_FOUR_MONTH_ORDERS]: {
      name: MetricTypes.TWENTY_FOUR_MONTH_ORDERS,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.TWENTY_FOUR_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
      name: MetricTypes.TWENTY_FOUR_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.TWENTY_FOUR_MONTH_CAC]: {
      name: MetricTypes.TWENTY_FOUR_MONTH_CAC,
      type: "CURRENCY",
      success_direction: "up",
      currencyCode: currencyCode,
    },
    [MetricTypes.META_AD_ACCOUNT_ID]: {
      name: MetricTypes.META_AD_ACCOUNT_ID,
      type: "STRING",
      success_direction: "up",
    },
    [MetricTypes.META_AD_ACCOUNT_NAME]: {
      name: MetricTypes.META_AD_ACCOUNT_NAME,
      type: "STRING",
      success_direction: "up",
    },
    [MetricTypes.ADSET_FIRST_USED]: {
      name: MetricTypes.ADSET_FIRST_USED,
      type: "STRING",
      success_direction: "up",
    },
    [MetricTypes.ADSET_LAST_USED]: {
      name: MetricTypes.ADSET_LAST_USED,
      type: "STRING",
      success_direction: "up",
    },
    [MetricTypes.ADSET_REGION]: {
      name: MetricTypes.ADSET_REGION,
      type: "STRING",
      success_direction: "up",
    },
    [MetricTypes.ADSET_NAME]: {
      name: MetricTypes.ADSET_NAME,
      type: "STRING",
      success_direction: "up",
    },
    [MetricTypes.ADSET_AUDIENCE]: {
      name: MetricTypes.ADSET_AUDIENCE,
      type: "STRING",
      success_direction: "up",
    },
    [MetricTypes.ADSET_IS_CATALOG]: {
      name: MetricTypes.ADSET_IS_CATALOG,
      type: "STRING",
      success_direction: "up",
    },
    [MetricTypes.CAMPAIGN_OBJECTIVE]: {
      name: MetricTypes.CAMPAIGN_OBJECTIVE,
      type: "STRING",
      success_direction: "up",
    },
    [MetricTypes.AUDIENCE_ENRICHMENT_ADSET_TARGETING]: {
      name: MetricTypes.AUDIENCE_ENRICHMENT_ADSET_TARGETING,
      type: "STRING",
      success_direction: "up",
    },
    [MetricTypes.ADSET_TARGETING]: {
      name: MetricTypes.ADSET_TARGETING,
      type: "STRING",
      success_direction: "up",
    },
    [MetricTypes.BENCHMARK_SAMPLE_SIZE]: {
      name: MetricTypes.BENCHMARK_SAMPLE_SIZE,
      type: "COUNT",
      success_direction: "up",
    },
    [MetricTypes.BENCHMARKED_MER]: {
      name: MetricTypes.BENCHMARKED_MER,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.BENCHMARKED_AMER]: {
      name: MetricTypes.BENCHMARKED_AMER,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.BENCHMARKED_BLENDED_AD_ATTRIBUTED_CONVERSION_ROAS]: {
      name: MetricTypes.BENCHMARKED_BLENDED_AD_ATTRIBUTED_CONVERSION_ROAS,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.BENCHMARKED_BLENDED_AD_COST_PER_IMPRESSION]: {
      name: MetricTypes.BENCHMARKED_BLENDED_AD_COST_PER_IMPRESSION,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.BENCHMARKED_BLENDED_AD_CLICK_THROUGH_RATE]: {
      name: MetricTypes.BENCHMARKED_BLENDED_AD_CLICK_THROUGH_RATE,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.BENCHMARKED_BLENDED_AD_COST_PER_CLICK]: {
      name: MetricTypes.BENCHMARKED_BLENDED_AD_COST_PER_CLICK,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.BENCHMARKED_GOOGLE_AD_ATTRIBUTED_CONVERSION_ROAS]: {
      name: MetricTypes.BENCHMARKED_GOOGLE_AD_ATTRIBUTED_CONVERSION_ROAS,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.BENCHMARKED_GOOGLE_AD_COST_PER_IMPRESSION]: {
      name: MetricTypes.BENCHMARKED_GOOGLE_AD_COST_PER_IMPRESSION,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.BENCHMARKED_GOOGLE_AD_CLICK_THROUGH_RATE]: {
      name: MetricTypes.BENCHMARKED_GOOGLE_AD_CLICK_THROUGH_RATE,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.BENCHMARKED_GOOGLE_AD_COST_PER_CLICK]: {
      name: MetricTypes.BENCHMARKED_GOOGLE_AD_COST_PER_CLICK,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.BENCHMARKED_GOOGLE_AD_RELATIVE_PERCENTAGE_SPEND]: {
      name: MetricTypes.BENCHMARKED_GOOGLE_AD_RELATIVE_PERCENTAGE_SPEND,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.BENCHMARKED_META_AD_ATTRIBUTED_CONVERSION_ROAS]: {
      name: MetricTypes.BENCHMARKED_META_AD_ATTRIBUTED_CONVERSION_ROAS,
      type: "RATE",
      success_direction: "up",
    },
    [MetricTypes.BENCHMARKED_META_AD_COST_PER_IMPRESSION]: {
      name: MetricTypes.BENCHMARKED_META_AD_COST_PER_IMPRESSION,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.BENCHMARKED_META_AD_CLICK_THROUGH_RATE]: {
      name: MetricTypes.BENCHMARKED_META_AD_CLICK_THROUGH_RATE,
      type: "PERCENTAGE",
      success_direction: "up",
    },
    [MetricTypes.BENCHMARKED_META_AD_COST_PER_CLICK]: {
      name: MetricTypes.BENCHMARKED_META_AD_COST_PER_CLICK,
      type: "CURRENCY",
      success_direction: "down",
      currencyCode: currencyCode,
    },
    [MetricTypes.BENCHMARKED_META_AD_RELATIVE_PERCENTAGE_SPEND]: {
      name: MetricTypes.BENCHMARKED_META_AD_RELATIVE_PERCENTAGE_SPEND,
      type: "PERCENTAGE",
      success_direction: "up",
    },
  }[metric];
};
